"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StyledModal = require("./StyledModal");

var _excluded = ["children", "closable", "destroyOnClose", "mask", "maskClosable", "maskStyle", "onCancel", "title", "visible", "width", "wrapClassName", "zIndex"];

function Modal(_ref) {
  var children = _ref.children,
      closable = _ref.closable,
      destroyOnClose = _ref.destroyOnClose,
      mask = _ref.mask,
      maskClosable = _ref.maskClosable,
      maskStyle = _ref.maskStyle,
      onCancel = _ref.onCancel,
      title = _ref.title,
      visible = _ref.visible,
      width = _ref.width,
      wrapClassName = _ref.wrapClassName,
      zIndex = _ref.zIndex,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StyledModal.StyledModal, (0, _extends2["default"])({
    visible: visible,
    closable: closable,
    destroyOnClose: destroyOnClose,
    mask: mask,
    maskClosable: maskClosable,
    maskStyle: maskStyle,
    onCancel: onCancel,
    title: title,
    width: width,
    wrapClassName: wrapClassName,
    zIndex: zIndex
  }, rest), children);
}

Modal.defaultProps = {
  children: null,
  closable: false,
  // Displays an x in the top right corner when true
  destroyOnClose: true,
  footer: null,
  mask: false,
  maskClosable: true,
  maskStyle: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)'
  },
  title: null,
  width: null,
  wrapClassName: 'vertical-center-modal',
  zIndex: 10000
};
Modal.propTypes = {
  children: _propTypes["default"].node,
  closable: _propTypes["default"].bool,
  destroyOnClose: _propTypes["default"].bool,
  footer: _propTypes["default"].node,
  mask: _propTypes["default"].bool,
  maskClosable: _propTypes["default"].bool,
  maskStyle: _propTypes["default"].shape({
    backgroundColor: _propTypes["default"].string
  }),
  onCancel: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].node,
  visible: _propTypes["default"].bool.isRequired,
  width: _propTypes["default"].number,
  wrapClassName: _propTypes["default"].string,
  zIndex: _propTypes["default"].number
};
var _default = Modal;
exports["default"] = _default;